import * as fromDatatype from '../datatype-library/index';

export interface bl_cms_form_submission_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    form_template_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    email_address: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    phone_number: fromDatatype.VarcharDatatypeInterface;
    cms_country_guid: fromDatatype.GuidDataFieldInterface;
    alpha3_code: fromDatatype.VarcharDatatypeInterface;
    subject_matter: fromDatatype.VarcharDatatypeInterface;
    status_processed: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_form_submission_hdr_RowClass implements bl_cms_form_submission_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    form_template_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    email_address: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    phone_number: fromDatatype.VarcharDatatypeInterface;
    cms_country_guid: fromDatatype.GuidDataFieldInterface;
    alpha3_code: fromDatatype.VarcharDatatypeInterface;
    subject_matter: fromDatatype.VarcharDatatypeInterface;
    status_processed: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}